<template>
  <oms-filter-dropdown :title="title || t('features.vue.orders.filters.tags')" icon='ri-price-tag-3-line' :is-filtering='isFiltering'>
    <p><strong>{{ t('features.vue.shared.filters.include') }}</strong></p>

    <label class='mr-3'>
      <input type='radio' value='all' :checked='!modelValue?.include?.filter_type || modelValue?.include?.filter_type === "all"'
        @change='emitInput("include", { filter_type: "all" })' />
      {{ t('features.vue.shared.filters.all_of') }}
    </label>
    <label>
      <input type='radio' value='any' :checked='modelValue?.include?.filter_type === "any"'
        @change='emitInput("include", { filter_type: "any" })' />
      {{ t('features.vue.shared.filters.any_of') }}
    </label>

    <multiselect class='multiselect--inline' :modelValue='modelValue?.include?.tags || []' :multiple='true' :options='tags'
      :show-labels='false' @update:modelValue='emitInput("include", { tags: $event })' />

    <p class='mt-3'><strong>{{ t('features.vue.shared.filters.exclude') }}</strong></p>

    <label class='mr-3'>
      <input type='radio' value='all' :checked='!modelValue?.exclude?.filter_type || modelValue?.exclude?.filter_type === "all"'
        @change='emitInput("exclude", { filter_type: "all" })' />
      {{ t('features.vue.shared.filters.all_of') }}
    </label>
    <label>
      <input type='radio' value='any' :checked='modelValue?.exclude?.filter_type === "any"'
        @change='emitInput("exclude", { filter_type: "any" })' />
      {{ t('features.vue.shared.filters.any_of') }}
    </label>

    <multiselect class='multiselect--inline' :modelValue='modelValue?.exclude?.tags || []' :multiple='true' :options='tags'
      :show-labels='false' @update:modelValue='emitInput("exclude", { tags: $event })' />
  </oms-filter-dropdown>
</template>

<script>
import Multiselect from 'vue-multiselect'
import OmsFilterDropdown from '../filter-dropdown.vue'

export default {
  inject: ['i18n'],

  props: {
    title: String,
    tags: Array,
    modelValue: Object
  },

  components: { Multiselect, OmsFilterDropdown },

  computed: {
    isFiltering() {
      return this.modelValue?.include?.tags?.length > 0 || this.modelValue?.exclude?.tags?.length > 0
    }
  },

  methods: {
    t(key, options) {
      return this.i18n ? this.i18n.t(key, options) : key
    },

    emitInput(type, fields) {
      this.$emit('update:modelValue', { ...(this.modelValue || {}), [type]: { ...this.modelValue[type], ...fields } })
    }
  },
}
</script>
